//#region src/utils/convert-file-info-to-data-file.ts
function e(e, t) {
	return {
		id: e.id,
		name: e.filename,
		filename: e.filename,
		path: e.path,
		thumbnail: e.thumbnail || null,
		source: t,
		size: e.size,
		type: e.type,
		createdAt: (/* @__PURE__ */ new Date()).toISOString()
	};
}
//#endregion
export { e as convertFileInfoToDataFile };
